import { useEffect, useMemo, useState } from "react";
import "./style.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../sidebar";
import Header from "../header";
import ApiClient from "../../../methods/api/apiClient";
import methodModel from "../../../methods/methods";
import { useDispatch, useSelector } from "react-redux";
import { login_success } from "../../../actions/user";

const Layout = ({ children }) => {
  const user = useSelector((state) => state.user);
  const history = useNavigate();
  const { pathname } = useLocation();

  const isMobile = useMemo(() => {
    let clientWidth = document.body.clientWidth;
    let value = false;
    if (clientWidth <= 769) value = true;
    return value;
  }, []);
  

  const [isOpen, setIsopen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!user.loggedIn) {
    } else {
      let browseload = localStorage.getItem("browseload");
      if (!browseload) {
        ApiClient.get("user/profile", { id: user._id }).then(async (res) => {
          if (res.success) {
            let data = { ...user, ...res.data };
            dispatch(login_success(data));
          }
        });
      }
    }
  }, []);


  useEffect(()=>{
    if(!isMobile){
      const shouldCollapseSidebar =
        pathname === "/checkin" ||
        pathname === "/inventory/product/add" ||
        pathname.startsWith("/inventory/product/edit/") ||
        pathname.startsWith("/inventory/product/detail/");

      setIsopen(shouldCollapseSidebar);
    }
  },[isMobile, pathname])

  const logowhite = () => {
    let value = "/assets/img/logo-white.png";
    return value;
  };

  const logos = () => {
    let value = "/assets/img/logo-white.png";
    return value;
  };

  const router = () => {
    let route = localStorage.getItem("route");
    history(route);
  };

  return (
    <>
      <div component="layout">
        <div onClick={(e) => router()} id="routerDiv"></div>
        <Header isOpen={isOpen} setIsOpen={setIsopen} />

        <div className={`main-wrapper flex ${isOpen ? "active-sidebar" : ""}`}>
          <div className="main-sidebar scrollbar pr-3 transition-[width] duration-300 ">
            <div className="sidebar-brand text-center">
              <Link to="/">
                <div className="editLogo">
                  <img
                    src={logowhite()}
                 
                    className=" h-24 object-contain show-logo"
                  />
                  <img src={logos()} className="hide-logo" />
                </div>
              </Link>
            </div>
            {user?.logo ? (
              <div
                className="flex justify-center"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={methodModel.userImg(user?.logo || "")}
                  alt="photo"
                  width="40"
                  height="40"
                  style={{
                    width: "40px",
                    marginBottom: "2px",
                    height: "40px",
                    borderRadius: "50%",
                  }}
                />
              </div>
            ) : null}
            <Sidebar isOpen={isOpen} setIsopen={setIsopen} />
            
          </div>
          <main className="main">
            <div className="mainarea ">
              {children}
            </div>
          </main>
        </div>
      </div>
    </>
  );
};
export default Layout;
